const mockPanchangaNow = {
  nakshatra: { index: 7, name_en: 'Pushya', name_ta: 'பூசம்', lord_en: 'Saturn', lord_ta: 'சனி', pada: 2 },
  tithi: { number: 5, name_en: 'Panchami', name_ta: 'பஞ்சமி', paksha: 'shukla' },
  hora: { planet_en: 'Jupiter', planet_ta: 'குரு', start: '10:30', end: '11:24' },
  tamil_yogam: { primary_en: 'Amirtha', primary_ta: 'அமிர்த', nature: 'auspicious' },
  active_periods: {
    nalla_neram: true,
    rahu_kaal: false,
    yamagandam: false,
    gulikai: false,
    varjyam: false,
    bhadra: false,
    panchaka: false,
    sarvartha_siddhi: true,
    amrit_siddhi: false,
  },
  choghadiya: { current_name: 'Labh', nature: 'auspicious' },
};

export function getMockPanchangaNow() {
  return { ...mockPanchangaNow, fetched_at: new Date().toISOString() };
}
